import axios from "axios";

// const BASE_URL = "https://job-auth-y09k.onrender.com/api/auth";
// const BASE_URL = "http://66.116.197.237:8000/api/auth";
const BASE_URL = "https://hourlee.in/api/auth";

export const sendOtp = async (phone, role) => {
  try {
    const response = await axios.post(`${BASE_URL}/send-otp-website`, {
      phoneNumber: phone,
      role,
    });
    return response.data;
  } catch (err) {
    throw err.response?.data || { message: err.message };
  }
};

export const verifyOtp = async (phoneNumber, otp) => {
  try {
    const response = await axios.post(`${BASE_URL}/verify-otp-website`, {
      phoneNumber,
      otp,
    });
    return response.data; // will contain status, result.token, result.role
  } catch (err) {
    throw err.response?.data || { message: err.message };
  }
};